module.exports = __webpack_public_path__ + "static/media/glitch.4507bbb0.gif";